export * from './QuoteV2';
export { quoteDarkBgVars, quoteWhiteBgVars } from './QuoteV2.palette';
